import React from "react";
import Link from "@mui/material/Link";

import { Icon } from "@formant/ui/component/common/Icon";

import { showMessenger } from "../../../utils/intercom";
import * as styles from "./index.scss";

interface IBillingAlertProps {
    prepaidAmount: number | undefined;
}
export function BillingAlert({ prepaidAmount }: IBillingAlertProps) {
    return (
        <div className={styles["billing-alert"]}>
            <Icon name="bulb" size="32" />
            <div className={styles["billing-alert-content"]}>
                <p className={styles["text-content"]}>
                    {prepaidAmount !== undefined && prepaidAmount > 0
                        ? `You use a lot of data! 
                        Ask us about increasing your prepaid amount.`
                        : "Want to lower your bill? Ask us about prepaid usage plans."}
                </p>
                <Link
                    className={styles["button-content"]}
                    component="button"
                    variant="body2"
                    onClick={showMessenger}
                >
                    Contact customer support
                </Link>
            </div>
        </div>
    );
}
